// extracted by css-extract-rspack-plugin
export default {"QueryBuilderBackButton":"QueryBuilderBackButton-module__QueryBuilderBackButton___A1ll4"};